<template>
  <popup ref="popup" :loading="popupLoading" :appendToBody="true">
    <div slot="body">
      <el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="120px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-table class="table" :data="parameter" stripe border height="auto">
              <el-table-column label="序号" width="50px" type="index"></el-table-column>
              <el-table-column prop="name" label="姓名" width="75px">
              </el-table-column>
              <el-table-column prop="mobile" label="电话" min-width="75px"></el-table-column>
              <el-table-column prop="sex" label="性别" min-width="40px"></el-table-column>
              <el-table-column prop="post" label="岗位" min-width="40px"></el-table-column>
              <el-table-column prop="state" min-width="70px" label="状态">
                <template slot-scope="scope">
                  <el-select v-if="scope.row.state != '已报名'" v-model="scope.row.state" placeholder="请选择">
                    <el-option v-for="item in [
    '可跟进',
    '想培训',
    '无意向',
    '已上门',
    '已体验测评',
    '已报名',
    '未接通',
    '废量']" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="rank" label="评价" min-width="100px">
                <template slot-scope="scope">
                  <el-rate show-text :max="4" v-model="scope.row.rank" :texts="['D', 'C', 'B', 'A']"></el-rate>
                </template>
              </el-table-column>
              <el-table-column min-width="300px" prop="remark" label="跟进情况">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.txt" autocomplete="off"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" :loading="confirmLoading" @click="confirm()">完成跟进</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/consultation/consultation.js";

export default {
  name: "attck",
  components: {
    popup,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: [],
      formParameter: {},
      rules: {},
    };
  },
  methods: {
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, "75%");
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.votes = [];
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.confirmLoading = true;

      let ids = [];
      let ranks = [];
      let remarks = [];
      let states = [];
      let isGo = true;


      this.parameter.forEach((element) => {
        ids.push(element.id);
        ranks.push(element.rank);
        remarks.push(element.txt);
        if (element.state == '已报名') {
          isGo = false;
        }
        states.push(element.state);
      });

      if (isGo) {
        let param = {
          ids: ids,
          ranks: ranks,
          remarks: remarks,
          states: states,
        };
        api.attact(
          param,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            this.$emit("flush");
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      } else {
        this.$utils.confirm.info("[已报名]状态不能使用批量跟进.");
        this.confirmLoading = false;
      }
    },
    init() {
      //清除等待
      this.confirmLoading = false;
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();
      this.popupLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
